export default __webpack_public_path__ + "static/media/Step-4_5.a948dde3.webm";